import { Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

export const MileageHelpText = () => {
  return (
    <HelpText as='div' variant='Body_15_Medium' color='textSecondary'>
      마일리지 추가 사용 가능한 스토어 상품으로 추가 적용중인 상품은 최대 7%까지 마일리지를 더 사용할 수 있어요.
      (마일리지는 1,000M 이상 보유 시에만 사용 가능)
    </HelpText>
  );
};

const HelpText = styled(Text)`
  line-height: 22px;
  padding-left: 4px;
  padding-right: 4px;
`;
